import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";

import * as api from "apis/oauthClient";

export function useOauthClients(options = {}) {
  const { message } = App.useApp();
  return useQuery(
    ["oauthClients"],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOauthClients();
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(error.message || "Failed to load data from server!"),
      ...options,
    }
  );
}

export function useOauthClient({ payload = {} }, options = {}) {
  const { message } = App.useApp();
  return useQuery(
    ["oauthClient", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOauthClient(payload?.id);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(error.message || "Failed to load data from server!"),
      ...options,
    }
  );
}

export const useAddOauthClient = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((data) => api.addOauthClient(data), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("appSetting.error_cannot_create")),
  });
};

export const useEditOauthClient = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((data) => api.editOauthClient(data), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("appSetting.error_cannot_create")),
  });
};

export const useDeleteOauthClient = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((id) => api.deleteOauthClient(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("appSetting.error_cannot_delete")),
  });
};
